var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('comp-room',_vm._g(_vm._b({ref:"adduser",attrs:{"sdkAppId":Number(_vm.sdkAppId),"secretKey":_vm.secretKey,"userId":_vm.userId,"roomId":Number(_vm.roomId),"cameraId":_vm.cameraId,"microphoneId":_vm.microphoneId}},'comp-room',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }